export function headerClearance() {
    const header = document.querySelector<HTMLElement>('[data-header]');

    if (!header) return;

    function update() {
        const height = header.offsetHeight;
        document.documentElement.style.setProperty('--header-clearance', `${height}px`);
    }

    update();
    window.addEventListener('resize', update);
}
